import { AdminHost } from 'static/classes/Host';
import { setDataAndShowDetailsModal } from 'static/components/details-modal/details-modal';

export function AllHostsViewModel(data){

    var self = this;
    self.type = "AllHostsViewModel";

    self.rootvm = data.rootvm;

    self.initialized = ko.observable(false);
    self.initialize = function(){

        if (self.offset() == undefined){
            self.offset(0);
        }
        if (self.limit() == undefined){
            self.limit(30);
        }

        if (!self.initialized()){
          self.lookup_hosts().then(function(){
                console.log('done looking up hosts');
                self.initialized(true);
          })
        };
    }

    self.total_count = ko.observable();
    self.filtered_count = ko.observable();
    self.offset = ko.observable();
    self.limit = ko.observable();

    self.hosts = ko.observableArray([]);

    self.error = ko.observable();
    self.person_name_search = ko.observable();

    self.host_statuses = ko.observableArray([
        {title:'created', value:'created'},
        {title:'published', value:'published'},
        {title:'paused', value:'paused'},
        {title:'deleted', value:'deleted'}
    ]);

    self.admin_ranking_options = ko.observableArray([0,1,2,3,4,5,6,7,8,9,10]);

    self.filter_host_state = ko.observable();

    self.order_by_column = ko.observable('inserted');
    self.sort_desc = ko.observable(true);

    self.set_selected_host_info = function(host){
        setDataAndShowDetailsModal(host, 'host');
    }

    self.search_click = function(){

        console.log('order column is ', self.order_by_column());
        self.offset(0);
        self.lookup_hosts();
        return false;
    }


    self.search_name = ko.observable();

    self.get_login_link = function(person){
        person.get_login_link('/manage/host/edit/basic');
    }

    self.lookup_hosts = function(){
        self.rootvm.is_busy(true);

        // we need to add in a filter as well..
        return $.ajax({

            url: self.rootvm.web_host + '/api/admin/hosts',
            type: 'GET',
            data:{
                limit: self.limit(),
                offset: self.offset(),
                search: self.search_name(),
                host_state: self.filter_host_state(),
                order_by_column : self.order_by_column(),
                sort_desc : self.sort_desc()
            },

            contentType: "application/json; charset=utf-8",
            success: function (data) {

                self.hosts(ko.utils.arrayMap( data.hosts || [],
                    function(x){
                        x.rootvm = self.rootvm
                        return new AdminHost(x);
                    }));

                self.total_count(data.total_count);
                self.filtered_count(data.filtered_count);
            },
            error: function (data) {
                self.error(data.statusText);
            },
            complete: function(){
                self.rootvm.is_busy(false);
            }
        });
    };

    self.lower_count_label = ko.computed(function(){
        return parseInt(self.offset()) + 1;
    });

    self.upper_count_label = ko.computed(function(){
        if (parseInt(self.limit()) + parseInt(self.offset()) > self.filtered_count())
        {
            return self.filtered_count();
        }
        else
        {
            return parseInt(self.limit()) + parseInt(self.offset());
        }
    });

    self.paging_visible = ko.computed(function () {
        return self.total_count() > 0;
    });

    self.next_button_visible = ko.computed(function() {
        return parseInt(self.offset()) + parseInt(self.limit()) < self.filtered_count();
    });

    self.previous_button_visible = ko.computed(function () {
        return parseInt(self.offset()) > 0;
    });



    self.go_left = function () {

        if (self.rootvm.is_busy()){
            return false;}

        self.offset(parseInt(self.offset()) - parseInt(self.limit()));
        if(self.offset() < 0){
            self.offset(0);
        }

        self.lookup_hosts().then(function(){
            pager.navigate("#community/hosts"
                + "?offset="
                + self.offset()
                + "&limit="
                + self.limit()
            );
        });
    };

    self.go_right = function () {

        if (self.rootvm.is_busy()){
            return false;}

        self.offset(parseInt(self.offset()) + parseInt(self.limit()));
        self.lookup_hosts().then(function(){
            pager.navigate("#community/hosts"
                + "?offset="
                + self.offset()
                + "&limit="
                + self.limit()
            );
           });
    };

};
